import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Card/Card'
import '@isceco/widget-library2/basic-elements/Link/Link'
import {BEWILLIGUNG_LINK_I18N_KEY} from './utils.js'

function renderLinkCard(ctx, url, i18nBase) {
  return html`
    <isceco-card>
      <isceco-link
        url="${url}"
        text="${ctx.i18n.translate(i18nBase)}"
        target="_blank"
      ></isceco-link>
      <p class="card-description">${ctx.i18n.translate(`${i18nBase}.description`)}</p>
    </isceco-card>
  `
}

export function renderRelevantLinks(ctx) {
  return html`
    <div class="relevant-links">
      <p class="relevant-links-title">${ctx.i18n.translate('footer.relevant-links.title')}</p>
      <div class="relevant-links-grid">
        ${renderLinkCard(ctx, ctx.i18n.translate('footer.startseite-entsendung.link'), 'footer.startseite-entsendung')}
        ${renderLinkCard(ctx, ctx.bewilligungUrl || ctx.i18n.translate(BEWILLIGUNG_LINK_I18N_KEY), 'footer.bewilligung-oder-meldung')}
        ${renderLinkCard(ctx, ctx.i18n.translate('footer.lohnspanne.link'), 'footer.lohnspanne')}
        ${renderLinkCard(ctx, ctx.i18n.translate('footer.meldeverfahren-easygov.link'), 'footer.meldeverfahren-easygov')}
      </div>
    </div>
  `
}
